export default __webpack_public_path__ + "static/media/antigeno.51e346e9.png";